<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">
                {{ snackbar_msg }}
            </span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box elevation-2 mx-2 mt-2">
            <v-toolbar class="toolbar" dense flat color="white">
                <v-toolbar-title class="font-weight-bold">
                    Offer Template
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small rounded color="success" @click="openDialog">
                    <v-icon small left>
                        mdi-plus
                    </v-icon>
                    Offer Template
                </v-btn>
            </v-toolbar>

            <v-row dense justify="center" class="pa-4">
                <v-col cols="12" sm="3" md="2">
                    <v-autocomplete color="#0F2027" dense rounded outlined return-object v-model="sel_ay_data"
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" persistent-hint
                        hint="Select Academic Year" @change="getStd">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="stream_list != null">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stream" :items="stream_list"
                        item-text="str" item-value="str_id" label="Stream" outlined persistent-hint
                        hint="Please Select Stream" />
                </v-col>

                <v-col cols="12" sm="3" md="2">
                    <v-autocomplete color="#0F2027" dense rounded outlined return-object v-model="sel_std_data"
                        :items="std_div_list" item-text="std" label="Standard" persistent-hint hint="Select Standard">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2" md="1">
                    <v-btn class="mt-0 button" :loading="loader" @click="getOfferTemplateList">
                        Fetch
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="offerTemplateList" class="elevation-1 mx-2 mt-2 rounded-table"
                v-if="isFetched && offerTemplateList.length != 0" :loading="loading"
                loading-text="Loading Please Wait..." :footer-props="{
                    'items-per-page-options': [10, 25, 50]
                }">

                <template v-slot:item.sr_no="{ item }">
                    <span class="font-weight-medium">
                        {{ item.sr_no }}
                    </span>

                </template>
                <template v-slot:item.ay="{ item }">
                    <v-chip small color="primary" outlined class="font-weight-medium">
                        {{ item.ay }}
                    </v-chip>
                </template>
                <template v-slot:item.stream="{ item }">
                    <v-chip small color="deep-purple" dark>
                        {{ item.stream }}
                    </v-chip>
                </template>
                <template v-slot:item.std="{ item }">
                    <span class="font-weight-medium">
                        {{ item.std }}
                    </span>
                </template>
                <template v-slot:item.associate_template="{ item }">
                    <v-btn small rounded color="info" dark @click="associateTemplate(item)">
                        <v-icon small left>
                            mdi-link-variant
                        </v-icon>
                        Associate
                    </v-btn>
                </template>
                <template v-slot:item.action="{ item }">
                    <div class="d-flex">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                    @click="editOfferTemplate(item)">
                                    <v-icon small>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small color="red" v-bind="attrs" v-on="on"
                                    @click="deleteOfferTemplate(item)">
                                    <v-icon small>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Delete</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" width="500" persistent>
            <v-card>
                <v-toolbar dense flat color="primary" dark>
                    <v-toolbar-title>
                        {{ form.id ? 'Edit' : '' }} Offer Template
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="mt-4">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete color="#0F2027" dense rounded outlined return-object
                                v-model="dialog_ay_data" :items="ay_std_div_list" item-text="ay" label="Academic Year"
                                persistent-hint hint="Select Academic Year" @change="getDialogStd">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-autocomplete color="#0F2027" dense rounded outlined return-object
                                v-model="dialog_stream_data" :items="dialog_stream_list" item-text="str" label="Stream"
                                persistent-hint hint="Select Stream">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-autocomplete color="#0F2027" dense rounded outlined return-object
                                v-model="dialog_std_data" :items="dialog_std_list" item-text="std" label="Standard"
                                persistent-hint hint="Select Standard">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-autocomplete color="#0F2027" dense rounded outlined return-object
                                v-model="dialog_temp_data" :items="templateList" item-text="name" label="Template"
                                persistent-hint hint="Select Template">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="closeDialog()">
                        Cancel
                    </v-btn>

                    <v-btn small color="primary" @click="saveOfferTemplate()">
                        {{ form.id ? 'Update' : 'Save' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
export default {

    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            dialog: false,
            loading: false,
            loader: false,
            offerTemplateList: [],
            academicYearList: [],
            standardList: [],
            form: {
                id: null,
                ay_id: null,
                std_id: null
            },

            headers: [
                { text: 'Sr No', value: 'sr_no' },
                { text: 'Academic Year', value: 'ay' },
                { text: 'Stream', value: 'stream' },
                { text: 'Standard', value: 'std' },
                { text: 'Template', value: 'template' },
                { text: 'Associate Template', value: 'associate_template' },
                // { text: 'Status', value: 'isactive' },
                { text: 'Action', value: 'action', sortable: false }

            ],
            ay_std_div_list: [],
            std_div_list: [],
            sel_ay_data: null,
            sel_std_data: null,
            isFetched: false,
            dialog_ay_data: null,
            dialog_std_data: null,
            dialog_temp_data: null,
            templateList: [],
            dialog_std_list: [],
            dialog_stream_list: [],
            offerTemplateList: [],
            stream: null,
            stream_list: [],
            dialog_stream_data: null,
        }
    },

    mounted() {
        this.onload();
        this.getTemplateList();
    },

    methods: {
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.stream_list = res.data.stream_list;
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        getTemplateList() {
            axios
                .post("/admission/getTemplateList")
                .then((res) => {
                    this.templateList = res.data.templateList;
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        getStd() {
            this.std_div_list = [];
            this.sel_std_data = null;
            this.stream = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },

        getDialogStd() {
            this.dialog_std_list = [];
            this.dialog_stream_list = [];
            this.dialog_std_data = null;
            this.dialog_std_list = this.dialog_ay_data.std_list;
            this.dialog_stream_list = this.stream_list;
        },

        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        },

        openDialog() {
            this.form = {
                id: null
            }
            this.dialog_ay_data = null
            this.dialog_stream_data = null
            this.dialog_std_data = null
            this.dialog_temp_data = null
            this.dialog_std_list = []
            this.dialog = true
        },

        closeDialog() {
            this.dialog = false
            this.form = {
                id: null
            }
            this.dialog_ay_data = null
            this.dialog_std_data = null
            this.dialog_stream_data = null
            this.dialog_temp_data = null
            this.dialog_std_list = []
        },

        getOfferTemplateList() {
            if (!this.sel_ay_data) {
                this.showSnackbar("#b71c1c", "Please select academic year");
                return;
            }

            if (!this.sel_std_data) {
                this.showSnackbar("#b71c1c", "Please select standard");
                return;
            }

            this.loader = true;

            let data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                stream: this.stream,
            };

            axios
                .post("/admission/getOfferTemplateList", data)

                .then((res) => {
                    this.loader = false;

                    if (res.data.flag == "YES" && res.data.offerTemplateList.length == 0) {
                        this.showSnackbar("#b71c1c", "No data available");
                        this.offerTemplateList = []
                    }

                    else if (res.data.flag == "YES") {
                        this.isFetched = true;
                        this.offerTemplateList = res.data.offerTemplateList;
                    }

                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })

                .catch(() => {
                    this.loader = false;
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        saveOfferTemplate() {

            if (!this.dialog_ay_data) {
                this.showSnackbar("#b71c1c", "Please Select Academic Year")
                return
            }

            if (!this.dialog_std_data) {
                this.showSnackbar("#b71c1c", "Please Select Standard")
                return
            }

            if (!this.dialog_stream_data) {
                this.showSnackbar("#b71c1c", "Please Select Stream")
                return
            }

            if (!this.dialog_temp_data) {
                this.showSnackbar("#b71c1c", "Please Select Template")
                return
            }

            let data = {
                id: this.form.id,
                ay_id: this.dialog_ay_data.ay_id,
                std_id: this.dialog_std_data.std_id,
                stream_id: this.dialog_stream_data.str_id,
                template_id: this.dialog_temp_data.id
            }

            let url = ""

            if (this.form.id) {
                url = "/admission/updateOfferTemplate"
            }
            else {
                url = "/admission/saveOfferTemplate"
            }

            axios
                .post(url, data)

                .then((res) => {

                    this.loader = false;

                    if (res.data.flag == "YES") {

                        this.showSnackbar("success", res.data.snackbar)

                        this.closeDialog()

                        this.getOfferTemplateList()

                    } else {

                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })

                .catch(() => {
                    this.loader = false;
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        editOfferTemplate(item) {
            this.form.id = item.id

            this.dialog_ay_data = this.ay_std_div_list.find(
                e => e.ay_id == item.ay_id
            )

            this.dialog_std_list = this.dialog_ay_data.std_list

            this.dialog_stream_list = this.stream_list

            this.dialog_std_data = this.dialog_std_list.find(
                e => e.std_id == item.std_id
            )

            this.dialog_stream_data = this.dialog_stream_list.find(
                e => e.str_id == item.stream_id
            )

            this.dialog_temp_data = this.templateList.find(
                e => e.id == item.template_id
            )

            this.dialog = true
        },

        deleteOfferTemplate(item) {

            if (!confirm("Are you sure you want to delete this record?")) {
                return
            }

            axios
                .post("/admission/deleteOfferTemplate", {
                    id: item.id
                })

                .then((res) => {

                    if (res.data.code == "200") {

                        this.showSnackbar("success", res.data.msg)

                        this.getOfferTemplateList()

                    } else {

                        this.showSnackbar("#b71c1c", res.data.msg)
                    }
                })

                .catch(() => {

                    this.showSnackbar("#b71c1c", "Something went wrong...")
                })
        },

        associateTemplate(item) {

            const routeData = this.$router.resolve({

                path: "/associate-template",

                query: {
                    offering_id: item.id
                }
            })

            window.open(routeData.href, "_blank")
        }

    }

}
</script>

<style scoped>
.v-data-table {
    border-radius: 4px;
}

.rounded-table {
    border-radius: 12px;
    overflow: hidden;
}

::v-deep .v-data-table-header {
    background: #f5f7fa;
}

::v-deep .v-data-table-header th {
    font-size: 13px !important;
    font-weight: 700 !important;
    color: #37474f !important;
}

::v-deep tbody tr:hover {
    background: #f9fbfd !important;
    transition: 0.2s ease;
}

::v-deep .v-data-table td {
    font-size: 13px;
}
</style>